import { FIXED_INDENTS } from 'vars/fixed-indents'

export const DropdownHeaderDirection = {
  Row: 'row',
  Column: 'column',
} as const
export type DropdownHeaderDirection =
  (typeof DropdownHeaderDirection)[keyof typeof DropdownHeaderDirection]

export const DropdownHeaderJustifyContent = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around',
  SpaceEvenly: 'space-evenly',
} as const
export type DropdownHeaderJustifyContent =
  (typeof DropdownHeaderJustifyContent)[keyof typeof DropdownHeaderJustifyContent]

export const DropdownHeaderAlignItems = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  Baseline: 'baseline',
} as const
export type DropdownHeaderAlignItems =
  (typeof DropdownHeaderAlignItems)[keyof typeof DropdownHeaderAlignItems]

type PaddingKey = 'SIZE_0' | 'SIZE_10'
export const DropdownHeaderPaddings: Record<
  PaddingKey,
  readonly [string, string, string, string]
> = {
  SIZE_0: [
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
  ],
  SIZE_10: [
    FIXED_INDENTS.INDENT_10,
    FIXED_INDENTS.INDENT_10,
    FIXED_INDENTS.INDENT_10,
    FIXED_INDENTS.INDENT_10,
  ],
} as const
export type DropdownHeaderPadding =
  (typeof DropdownHeaderPaddings)[keyof typeof DropdownHeaderPaddings]
